import type { ReactNode } from 'react';

/**
 * Flat settings section — heading + hairline, no card box. Header row (`.sh`)
 * places the title on the left and an optional quiet note OR action on the
 * right, over a `border-bottom` hairline. Cards are reserved for the webshop
 * tiles and the danger-zone only.
 */
export function FlatSection({
  id,
  title,
  titleExtra,
  titleDanger,
  note,
  action,
  children,
}: {
  id?: string;
  title: string;
  titleExtra?: ReactNode;
  titleDanger?: boolean;
  note?: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section id={id} style={{ scrollMarginTop: 78, minWidth: 0 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 14,
          paddingBottom: 12,
          marginBottom: 18,
          borderBottom: '1px solid var(--border-subtle)',
        }}
      >
        <h2
          className="text-text-primary"
          style={{
            fontSize: 16,
            fontWeight: 500,
            letterSpacing: '-0.01em',
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 9,
            color: titleDanger ? 'var(--color-danger)' : undefined,
          }}
        >
          {title}
          {titleExtra}
        </h2>
        {note && (
          <span className="text-text-muted" style={{ fontSize: 12.5, lineHeight: 1.5, textAlign: 'right' }}>
            {note}
          </span>
        )}
        {action}
      </div>
      {children}
    </section>
  );
}

/** Quiet mono "voor ontwikkelaars"-style tag pill for section titles. */
export function DevTag({ children }: { children: ReactNode }) {
  return (
    <span
      className="font-mono text-text-muted lowercase border border-border-default inline-flex items-center"
      style={{ fontSize: 10, borderRadius: 3, padding: '1px 7px' }}
    >
      {children}
    </span>
  );
}
